import { Antwort } from '../fragebogen/antwort.model';
export class Frage {
  id: string;
  fragestellung: string;
  typ: string;
  typNumber: number;
  fragebogenId: string;
  fragebogenName: string;
  sortierung: number;
  antworten: Antwort[] = Array<Antwort>();
  elternantworten: Antwort[] = Array<Antwort>();
  elternfrage: Frage;
  gesperrt: boolean;
  verstecken: boolean;
}